import { useState, useRef, useCallback } from 'react'
import { Conversation } from '@elevenlabs/client'

export function useElevenLabs() {
  const [status, setStatus] = useState('idle')   // idle | connecting | connected | error
  const [mode, setMode] = useState('idle')   // idle | speaking | listening
  const [transcript, setTranscript] = useState(null)
  const [error, setError] = useState(null)
  const convRef = useRef(null)

  const start = useCallback(async () => {
    setStatus('connecting')
    setError(null)

    // 1️⃣ Pedir micrófono
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true })
    } catch {
      setError('Micrófono bloqueado — habilítalo en el navegador')
      setStatus('idle')
      return
    }

    // 2️⃣ Pedir signed URL a nuestro backend Express
    let signedUrl
    try {
      const res = await fetch('https://9vxirffv76.execute-api.us-east-1.amazonaws.com/dev/token')
      if (!res.ok) throw new Error(`Error ${res.status}`)
      const data = await res.json()
      if (!data.signedUrl) throw new Error('No se recibió signedUrl')
      signedUrl = data.signedUrl
    } catch (e) {
      setError('No se pudo obtener el token: ' + e.message)
      setStatus('idle')
      return
    }

    // 3️⃣ Iniciar sesión con ElevenLabs
    try {
      convRef.current = await Conversation.startSession({
        signedUrl,

        onConnect: () => {
          setStatus('connected')
          setMode('listening')
        },

        onDisconnect: () => {
          setStatus('idle')
          setMode('idle')
          convRef.current = null
        },

        onModeChange: ({ mode }) => {
          setMode(mode === 'speaking' ? 'speaking' : 'listening')
        },

        onMessage: ({ source, message }) => {
          setTranscript({ role: source === 'ai' ? 'agent' : 'user', text: message })
        },

        onError: (msg) => {
          setError(msg)
          setStatus('error')
          setMode('idle')
        },
      })
    } catch (e) {
      setError(e?.message || 'No se pudo conectar')
      setStatus('idle')
    }
  }, [])

  const stop = useCallback(async () => {
    if (convRef.current) {
      await convRef.current.endSession()
      convRef.current = null
    }
    setStatus('idle')
    setMode('idle')
  }, [])

  return { status, mode, transcript, error, start, stop }
}
